console.log("init Proteus treatments -- v1.01")

if(getParam("cart") == "open"){
  waitForElement('[aria-controls="cart-drawer"]').then(cart_trigger => {
    cart_trigger.click();
  }).catch()
}

/* START support for [BRE-01] */
let free_burger_press = () => {
  
  window.sessionStorage.setItem("[BRE-01] activate Burger Press GWP", true);
  let burger_press_var_id = 42490257834029;

  // logic for all NOT /cart pages
  let assess_cart = (cart_total) => {

    waitUntil(() => {
      return typeof window.cart_data != "undefined" && typeof window.cart_data.items != "undefined";
    }).then(() => {

      let burger_press_in_cart = window.cart_data.items.some(item => item.title.toLowerCase().includes('breeo burger press'));
      if(!burger_press_in_cart && window.cart_data.total_price >= 39800 && !window.sessionStorage.getItem("[BRE-01] Burger Press GWP added")){
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: burger_press_var_id, 
              quantity: 1
            }]
          })
        }).then(response => response.json()).then(cart => {
          console.log("assess_cart item added"),
          window.sessionStorage.setItem("[BRE-01] Burger Press GWP added", true);
          window.location.href = `/discount/FREEPRESS?redirect=${window.location.pathname}?cart=open`;
        }).catch(error => {
          console.error('Error adding item to cart:', error);
        });
        
      }
      
    }).catch();
    
  };

  // init
  assess_cart();

  document.addEventListener('rebuy:cart.change', (event) => { 
    assess_cart(event.detail.cart.subtotal()); 
  });

  document.addEventListener('rebuy:cart.ready', (event) => { 
    // assess_cart(event.detail.cart.subtotal());
  });
  
};

if(window.sessionStorage.getItem("[BRE-01] activate Burger Press GWP") ||
  getParam("free_burger_press") ||
  getParam("utm_campaign").toLowerCase().indexOf("burger press") > -1){
  free_burger_press();
}

window.addEventListener("klaviyoForms", function(e) { 
  console.log("klaviyoForms event", e.detail)
  if (e.detail.type == 'submit' && e.detail.formId == "W2VaPf") {
    free_burger_press();
  }
});
/* START support for [BRE-01] */